__turbopack_context__.v({
  "contentContainer": "styles-module__TFNc5W__contentContainer",
  "dropdownContainer": "styles-module__TFNc5W__dropdownContainer",
  "fadeIn": "styles-module__TFNc5W__fadeIn",
});
